import React, { useState } from "react";
import { Badge, Form, Modal, Spinner } from "react-bootstrap";

const AddQueryOperatorModal = ({
  Show,
  Hide,
  setOperator,
  operator,
  setQuery,
  query,
  miniOperator
}) => {
    const [buttonLoader, setButtonLoader] = useState(false);
  
  const addNewQueryOperatorModal = (operator) => {
    setButtonLoader(true);
    const newOption = {
      id: Math.floor(1000000000 + Math.random() * 9000000000),
      type: "operator",
      value: operator || ""
    };
    let updatedQuery = [...query]
    if (newOption) {
      setQuery([...updatedQuery, newOption])
      setOperator("")
      Hide()
    }
    setButtonLoader(false);
  };
  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            Add Operator
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-2">
              Operator{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <div className="hstack gap-2 flex-wrap">
              <Badge onClick={() => setOperator("+")} className="br3 text-dark CP" bg={operator === "+" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Add Operator">+</Badge>
              <Badge onClick={() => setOperator("-")} className="br3 text-dark CP" bg={operator === "-" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Sunstract Operator">-</Badge>
              <Badge onClick={() => setOperator("*")} className="br3 text-dark CP" bg={operator === "*" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Multiply Operator">{'x'}</Badge>
              <Badge onClick={() => setOperator("/")} className="br3 text-dark CP" bg={operator === "/" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Devision Operator">{'÷'}</Badge>
              <Badge onClick={() => setOperator("**")} className="br3 text-dark CP" bg={operator === "**" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Power Operator">{'**'}</Badge>
              <Badge onClick={() => setOperator(">")} className="br3 text-dark CP" bg={operator === ">" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Grater Than Operator">{'>'}</Badge>
              <Badge onClick={() => setOperator("<")} className="br3 text-dark CP" bg={operator === "<" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Less Than Operator">{'<'}</Badge>
              <Badge onClick={() => setOperator("===")} className="br3 text-dark CP" bg={operator === "===" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Equal To Operator">{'='}</Badge>
              <Badge onClick={() => setOperator("!=")} className="br3 text-dark CP" bg={operator === "!=" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Not Equal To Operator">{'!='}</Badge>
              <Badge onClick={() => setOperator("<=")} className="br3 text-dark CP" bg={operator === "<=" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Less Than Equal To Operator">{'<='}</Badge>
              <Badge onClick={() => setOperator(">=")} className="br3 text-dark CP" bg={operator === ">=" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Grater Than Equal To Operator">{'>='}</Badge>
              <Badge onClick={() => setOperator("||")} className="br3 text-dark CP" bg={operator === "||" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="OR Operator">{'OR'}</Badge>
              <Badge onClick={() => setOperator("&&")} className="br3 text-dark CP" bg={operator === "&&" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="AND Operator">{'AND'}</Badge>
              <Badge onClick={() => setOperator("(")} className="br3 text-dark CP" bg={operator === "(" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Open Bracket Operator">{'('}</Badge>
              <Badge onClick={() => setOperator(")")} className="br3 text-dark CP" bg={operator === ")" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Closed Bracket Operator">{')'}</Badge>
              {miniOperator &&
                <>
                  <Badge onClick={() => setOperator("if")} className="br3 text-dark CP" bg={operator === "if" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="If Statement">{'IF'}</Badge>
                  <Badge onClick={() => setOperator("then")} className="br3 text-dark CP" bg={operator === "then" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Then Result">{'THEN'}</Badge>
                  <Badge onClick={() => setOperator("else")} className="br3 text-dark CP" bg={operator === "else" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Else Condition">{'ELSE'}</Badge>
                  <Badge onClick={() => setOperator("else if")} className="br3 text-dark CP" bg={operator === "else if" ? "danger text-white" : "danger-subtle"} style={{ fontSize: 12 }} title="Else If Statement">{'ELSE IF'}</Badge>
                </>
              }
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="p-1 px-3 bg-light">
          <button
            className="updateProfile"
            disabled={!operator}
            onClick={() => addNewQueryOperatorModal(operator)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Adding...
              </div>
            ) : (
              "Add New"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddQueryOperatorModal;
